import { Variant } from '../../types/product';

const getSelectedVariantId = (variantsData: Variant[], selectedOptions: string[]): number | null => {
  // Find variant id using selected options values
  const findSelectedOptionsVariantId = (selectedOptions: string[]): Variant | undefined => {
    // Find a variant in variant data JSON matching the selected options values
    return variantsData.find((variant): boolean => {
      // Check if number of options matches and every option equals the selected value
      return variant.options.length === selectedOptions.length &&
        // For each option, compare it with the value selected by the user at the same index
        variant.options.every((option, index): boolean => option === selectedOptions[index]);
    });
  };
  let variantId: number | null = null;
  const variant = findSelectedOptionsVariantId(selectedOptions);
  variant ? variantId = variant.id : variantId = null;
  return variantId;
};

export default getSelectedVariantId;
